import { render, staticRenderFns } from "./ReasonLevelThree.vue?vue&type=template&id=c6ec37be"
import script from "./ReasonLevelThree.vue?vue&type=script&lang=js"
export * from "./ReasonLevelThree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports